import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Make an authenticated fetch request
 * Automatically adds the Cognito JWT token to the Authorization header
 */
export async function authenticatedFetch(url, options = {}) {
    try {
        // Get the current auth session
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        if (!token) {
            throw new Error('No authentication token available');
        }

        // Merge headers with authorization
        const headers = {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
        };

        // Make the fetch request with the token
        const response = await fetch(url, {
            ...options,
            headers,
        });

        // Handle 401 Unauthorized - token may have expired
        if (response.status === 401) {
            // Redirect to login
            window.location.href = '/login';
            throw new Error('Authentication expired. Please log in again.');
        }

        return response;
    } catch (error) {
        console.error('Authenticated fetch error:', error);
        throw error;
    }
}

/**
 * Convenience method for GET requests
 */
export async function authenticatedGet(url) {
    return authenticatedFetch(url, { method: 'GET' });
}

/**
 * Convenience method for POST requests
 */
export async function authenticatedPost(url, data) {
    return authenticatedFetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}

/**
 * Convenience method for PUT requests
 */
export async function authenticatedPut(url, data) {
    return authenticatedFetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}

/**
 * Convenience method for DELETE requests
 */
export async function authenticatedDelete(url) {
    return authenticatedFetch(url, { method: 'DELETE' });
}
